import { Link, NavLink } from 'react-router-dom';
import { AREAS } from '../../lib/u99';
import PublicationsMenu from './PublicationsMenu';

const isActive = (to, pathname) => (to === '/u99' ? pathname === '/u99' : pathname.startsWith(to));

export default function U99Nav({ pathname }) {
  return (
    <>
      <header className="fixed top-0 inset-x-0 z-50 h-16 border-b border-white/[0.06] bg-[#02040a]/80 backdrop-blur-xl" data-testid="u99-nav">
        <div className="max-w-7xl mx-auto px-5 lg:px-10 h-full flex items-center justify-between">
          <Link to="/u99" className="flex items-center gap-3 group" data-testid="u99-brand">
            <span className="relative w-7 h-7 rounded-full border border-amber-400/60 grid place-items-center">
              <span className="font-celestial text-[10px] text-amber-300">99</span>
              <span className="absolute inset-0 rounded-full border border-amber-400/30 animate-ping [animation-duration:3s]" />
            </span>
            <span className="whitespace-nowrap font-celestial text-xs sm:text-sm tracking-[0.25em] text-slate-100 group-hover:text-amber-200 transition-colors">UNITED 99 <span className="text-amber-300">UNLEASHED</span></span>
          </Link>
          <nav className="hidden md:flex items-center gap-1" data-testid="u99-nav-desktop">
            {AREAS.map((a) => (
              <div key={a.id} className="relative group">
                <NavLink to={a.to} end={a.to === '/u99'} className={({ isActive: on }) => `block whitespace-nowrap font-mono-precision text-[10.5px] lg:text-[11px] uppercase tracking-[0.2em] px-3 lg:px-4 py-2 rounded-full transition-colors duration-300 ${on ? 'text-amber-300 bg-amber-400/[0.08]' : 'text-slate-400 hover:text-slate-100'}`} data-testid={`u99-nav-${a.id}`}>
                  {a.label}
                </NavLink>
                {a.id === 'documents' && <PublicationsMenu />}
              </div>
            ))}
          </nav>
          <Link to="/u99/library" className="hidden md:block whitespace-nowrap font-mono-precision text-[9px] uppercase tracking-[0.2em] text-amber-300/80 hover:text-amber-200 transition-colors" data-testid="u99-nav-library-link">Library</Link>
          <Link to="/" className="hidden md:block whitespace-nowrap font-mono-precision text-[9px] uppercase tracking-[0.2em] text-slate-600 hover:text-cyan-300 transition-colors" data-testid="u99-nav-studio-link">Sidetrack AI ↗</Link>
        </div>
      </header>

      <nav className="md:hidden fixed bottom-0 inset-x-0 z-50 border-t border-white/[0.08] bg-[#02040a]/95 backdrop-blur-xl pb-[env(safe-area-inset-bottom)]" data-testid="u99-nav-mobile">
        <div className="grid grid-cols-5">
          {AREAS.map((a) => {
            const on = isActive(a.to, pathname);
            const Icon = a.icon;
            return (
              <Link key={a.id} to={a.to} className={`flex flex-col items-center gap-1 py-2.5 transition-colors ${on ? 'text-amber-300' : 'text-slate-500'}`} data-testid={`u99-tab-${a.id}`}>
                <Icon size={18} strokeWidth={on ? 2 : 1.5} />
                <span className="font-mono-precision text-[8.5px] uppercase tracking-[0.12em] leading-none">{a.id === 'mind' ? 'Mind' : a.id === 'tools' ? 'Tools' : a.label}</span>
              </Link>
            );
          })}
        </div>
      </nav>
    </>
  );
}
